import React from 'react'

import { Link } from 'react-scroll'

const Header = () => {
  return (
    <header className="py-8">
      <div className="container mx-auto">
        <div className="flex justify-between">
          {/* my logo */}
          <div className="w-[150px]">
            <a href="#">
              <h1 className="text-gradient text-[1.7rem] font-bolder">
                Daniel
              </h1>
              <h1 className="text-3xl font-extrabold">Agbeleshe</h1>
            </a>
          </div>
          <Link smooth={true}  to="contact">
            <button className="btn btn-sm font-bold">Work with me</button>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default Header
